import { Grid, Tooltip, styled, useTheme } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardChipIcon, ConditionalWrapper, DotIcon, TrashCanIcon } from '../../../Shared';
import { CardButtonStyled } from '../styledSubscriptionComponents';
import { useToast } from '../../../../Helpers/Hooks/useToast';
import { useWindowDimensions } from '../../../../Helpers/Hooks/useWindowDimensions';
import { IGetCardsSubscriptionDto } from '../../../../API/Interfaces/OpenSubscription/IGetCardsSubscriptionDto';

interface CreditCardProps {
	setShowDeleteModal: React.Dispatch<
		React.SetStateAction<{
			show: boolean;
			cardId: string;
		}>
	>;
	card: IGetCardsSubscriptionDto;
	setSelectedCard: React.Dispatch<React.SetStateAction<IGetCardsSubscriptionDto>>;
	selectedCard: IGetCardsSubscriptionDto;
}

const CardDiv = styled(`div`)(() => ({
	display: 'flex',
	justifyContent: 'center',
	marginTop: '10px',
	marginLeft: '-10px',
}));

const DateDiv = styled(`div`)(() => ({
	marginTop: '10px',
	alignSelf: 'flex-start',
}));

const LastDigits = styled(`span`)(() => ({
	marginLeft: '10px',
	letterSpacing: '3px',
}));
const DotIconStyled = styled(DotIcon)(() => ({
	marginTop: '6px',
	width: '12px',
	height: '12px',
}));

export const CreditCard = ({ setShowDeleteModal, card, setSelectedCard, selectedCard }: CreditCardProps) => {
	const { isMobile } = useWindowDimensions();
	const { t } = useTranslation();
	const toast = useToast();
	const theme = useTheme();

	return (
		<Grid
			item
			style={{ margin: isMobile ? 'auto' : '' }}
			onClick={() => {
				if (moment(card.cardExpiryDate) < moment()) {
					toast(t('automaticPaymentPage.cardExpired'));
				} else setSelectedCard(card);
			}}
		>
			<CardButtonStyled isMobile={isMobile} defaultCard={card.id !== selectedCard.id}>
				<ConditionalWrapper
					condition={!card.isRemovable}
					wrapper={(children: any) => (
						<Tooltip
							enterTouchDelay={0}
							leaveTouchDelay={3000}
							title={t('automaticPaymentPage.removeTooltip')}
						>
							{children}
						</Tooltip>
					)}
				>
					<div style={{ alignSelf: 'flex-end' }} onClick={(e) => e.stopPropagation()}>
						<TrashCanIcon
							color={!card.isRemovable ? theme.palette.borders.primary : undefined}
							onClick={() => card.isRemovable && setShowDeleteModal({ show: true, cardId: card.id })}
						/>
					</div>
				</ConditionalWrapper>

				<CardChipIcon />
				<CardDiv>
					{' '}
					{[...Array(15)].map((_, index) =>
						index % 5 === 0 ? (
							<span key={index} style={{ marginRight: '10px' }} />
						) : (
							<DotIconStyled key={index} />
						)
					)}{' '}
					<LastDigits>{card.lastFourDigits}</LastDigits>
				</CardDiv>
				<DateDiv>{moment(card.cardExpiryDate).format('MM/YY')}</DateDiv>
			</CardButtonStyled>
		</Grid>
	);
};
